import React from 'react';

const FrontPageBriefcase = () => {
    return (
        <div className="briefcase-intro">
            {/* Contenedor de Logos y Título */}
            <div className="briefcase-intro__logo-container">
                <div className='d-flex align-items-center justify-content-center'>
                    {/* <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '120px', marginRight: '40px' }} alt="Sponsor" /> */}
                    
                    {/* Puedes cambiar esta imagen central por el logo del patrocinador oficial de esta dinámica */}
                    <img src="/img/page/xolos-five.png" className="briefcase-intro__logo" alt="Patrocinador Central" />
                    
                    {/* <img src='/img/favicon/Big.png' style={{ width: '100%', maxWidth: '120px', marginLeft: '30px' }} alt="Sponsor" /> */}
                </div>
                
                <p className="briefcase-intro__text text-uppercase fw-bold mt-4">Presentan</p>
                <p className="briefcase-intro__title text-uppercase fw-black">Vas o No Vas</p>
            </div>

            {/* El maletín animado que flota en el centro */}
            <div className='d-flex'>
                {/* <img src="/img/games/briefcase/Lucho.png" className="briefcase-intro__briefcase--Animation" style={{ width: '200px', height: '230px', marginTop: '60px', marginRight: '40px' }} alt="Maletín Misterioso" /> */}
                <img src="/img/games/briefcase/cerrado.png" className="briefcase-intro__briefcase" alt="Maletín Misterioso" />
                {/* <img src="/img/games/briefcase/Tunita.png" className="briefcase-intro__briefcase--Animation" style={{ width: '200px', height: '230px', marginTop: '60px', marginLeft: '40px' }} alt="Maletín Misterioso" /> */}
            </div>

            <p className='FooterCredits' style={{ position: 'fixed', bottom: '0', left: '50%', transform: 'translateX(-50%)' }}>Hecho con ♥ por Interaktia | 2026</p>
        </div>
    );
};

export { FrontPageBriefcase };